import { render } from "./ChangeSubscriptionComponent.vue?vue&type=template&id=32e4526c"
import script from "./ChangeSubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./ChangeSubscriptionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__